// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./browser/Browser__Tabs.bs.js");
var Browser__Windows$SmartcutsMacros = require("./browser/Browser__Windows.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");

function bridgeWindows_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var windowIdsInBackgroundMode = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowIdsInBackgroundMode"), null));
  if (windowIdsInBackgroundMode.TAG === /* Ok */0) {
    var minimizedWindowIdMapPlaybackTabId = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "minimizedWindowIdMapPlaybackTabId"), null));
    if (minimizedWindowIdMapPlaybackTabId.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                windowIdsInBackgroundMode: windowIdsInBackgroundMode._0,
                minimizedWindowIdMapPlaybackTabId: minimizedWindowIdMapPlaybackTabId._0
              }
            };
    }
    var e = minimizedWindowIdMapPlaybackTabId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".minimizedWindowIdMapPlaybackTabId" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = windowIdsInBackgroundMode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".windowIdsInBackgroundMode" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function bridgeWindows_encode(v) {
  return Js_dict.fromArray([
              [
                "windowIdsInBackgroundMode",
                Decco.arrayToJson(Decco.intToJson, v.windowIdsInBackgroundMode)
              ],
              [
                "minimizedWindowIdMapPlaybackTabId",
                CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_encode, v.minimizedWindowIdMapPlaybackTabId)
              ]
            ]);
}

function t_encode(v) {
  if (v) {
    return [
            "Windows",
            bridgeWindows_encode(v._0)
          ];
  } else {
    return ["MacOsAndUnixLike"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "MacOsAndUnixLike" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MacOsAndUnixLike */0
                  };
          }
      case "Windows" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = bridgeWindows_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Windows */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(osBridge) {
  if (!osBridge) {
    return "MacOsAndUnixLike";
  }
  var match = osBridge._0;
  return "Windows({windowIdsInBackgroundMode: [" + (Belt_Array.map(match.windowIdsInBackgroundMode, (function (prim) {
                    return String(prim);
                  })).join(", ") + ("], minimizedWindows: [" + (Belt_Array.map(Belt_MapInt.keysToArray(match.minimizedWindowIdMapPlaybackTabId), (function (prim) {
                        return String(prim);
                      })).join(", ") + "]})")));
}

function doesRequireWindowsBackgroundModeSupport(windowId, osBridge) {
  if (osBridge) {
    return $$Array.mem(windowId, osBridge._0.windowIdsInBackgroundMode);
  } else {
    return false;
  }
}

function markWindowIdAsMinimized(windowId, playbackTabId, osBridge) {
  if (!osBridge) {
    return /* MacOsAndUnixLike */0;
  }
  var bridgeWindows = osBridge._0;
  return /* Windows */{
          _0: {
            windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
            minimizedWindowIdMapPlaybackTabId: Belt_MapInt.set(bridgeWindows.minimizedWindowIdMapPlaybackTabId, windowId, playbackTabId)
          }
        };
}

function markWindowIdAsNotMinimized(windowId, osBridge) {
  if (!osBridge) {
    return /* MacOsAndUnixLike */0;
  }
  var bridgeWindows = osBridge._0;
  return /* Windows */{
          _0: {
            windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
            minimizedWindowIdMapPlaybackTabId: Belt_MapInt.remove(bridgeWindows.minimizedWindowIdMapPlaybackTabId, windowId)
          }
        };
}

function isWindowMinimized(windowId, osBridge) {
  if (osBridge) {
    return Belt_MapInt.has(osBridge._0.minimizedWindowIdMapPlaybackTabId, windowId);
  } else {
    return false;
  }
}

function maybeMinimizedWindowIdForTab(tabId, osBridge) {
  if (!osBridge) {
    return ;
  }
  var arg = Belt_MapInt.toArray(osBridge._0.minimizedWindowIdMapPlaybackTabId);
  var param = function (param$1) {
    if (Caml_obj.caml_equal(tabId, param$1[1])) {
      return param$1[0];
    }
    
  };
  return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
}

function createWindowWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpenerOpt, param) {
  var setSelfAsOpener = setSelfAsOpenerOpt !== undefined ? setSelfAsOpenerOpt : true;
  if (focused !== undefined && !focused && Caml_obj.caml_notequal(state, "minimized")) {
    return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, undefined, undefined, undefined, undefined, undefined, incognito, type_, "minimized", setSelfAsOpener, undefined).then(function ($$window) {
                var arg = $$window.id;
                var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
                var windowId = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    })("Expect window.id");
                return Browser__Windows$SmartcutsMacros.update(windowId, left, top, width, height, focused, undefined, state, undefined);
              });
  }
  return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined);
}

function createWindowWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpenerOpt, param) {
  var setSelfAsOpener = setSelfAsOpenerOpt !== undefined ? setSelfAsOpenerOpt : true;
  if (focused !== undefined && !focused && Caml_obj.caml_notequal(state, "minimized")) {
    return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, undefined, undefined, undefined, undefined, undefined, incognito, type_, "minimized", setSelfAsOpener, undefined).then(function ($$window) {
                var arg = $$window.id;
                var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
                var windowId = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    })("Expect window.id");
                return Browser__Windows$SmartcutsMacros.update(windowId, left, top, width, height, focused, undefined, state, undefined);
              });
  }
  return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined);
}

function createTab(maybeWindowId, index, url, active, selected, pinned, openerTabId, osBridge) {
  if (maybeWindowId !== undefined && doesRequireWindowsBackgroundModeSupport(maybeWindowId, osBridge)) {
    return Browser__Windows$SmartcutsMacros.update(maybeWindowId, undefined, undefined, undefined, undefined, undefined, undefined, "minimized", undefined).then(function (_window) {
                  return Browser__Tabs$SmartcutsMacros.create(maybeWindowId, index, url, active, selected, pinned, openerTabId, undefined);
                }).then(function (tab) {
                var arg = tab.id;
                var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
                var tabId = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    })("Expect tab.id");
                var nextPlaybackBridgeOs;
                if (osBridge) {
                  var bridgeWindows = osBridge._0;
                  nextPlaybackBridgeOs = /* Windows */{
                    _0: {
                      windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
                      minimizedWindowIdMapPlaybackTabId: Belt_MapInt.set(bridgeWindows.minimizedWindowIdMapPlaybackTabId, maybeWindowId, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.makePlaybackId(tabId))
                    }
                  };
                } else {
                  nextPlaybackBridgeOs = Util$SmartcutsMacros.logAndRaiseJsError("Expect Windows(_) when calling Windows.createTab()");
                }
                return Promise.resolve([
                            tab,
                            nextPlaybackBridgeOs
                          ]);
              });
  }
  return Browser__Tabs$SmartcutsMacros.create(maybeWindowId, index, url, active, selected, pinned, openerTabId, undefined).then(function (tab) {
              return Promise.resolve([
                          tab,
                          osBridge
                        ]);
            });
}

var Windows = {
  createWindowWithNoUrl: createWindowWithNoUrl,
  createWindowWithUrl: createWindowWithUrl,
  createTab: createTab
};

var MacOsAndUnixLike = {
  createWindowWithNoUrl: Browser__Windows$SmartcutsMacros.createWithNoUrl,
  createWindowWithUrl: Browser__Windows$SmartcutsMacros.createWithUrl,
  createTab: Browser__Tabs$SmartcutsMacros.create
};

function fromBrowserPlatformOs(platformOs) {
  if (platformOs !== 1) {
    return /* MacOsAndUnixLike */0;
  } else {
    return /* Windows */{
            _0: {
              windowIdsInBackgroundMode: [],
              minimizedWindowIdMapPlaybackTabId: undefined
            }
          };
  }
}

function createWindowWithNoUrl$1(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, osBridge) {
  if (!osBridge) {
    return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function ($$window) {
                return Promise.resolve([
                            $$window,
                            osBridge
                          ]);
              });
  }
  var bridgeWindows = osBridge._0;
  var windowIdsInBackgroundMode = bridgeWindows.windowIdsInBackgroundMode;
  return createWindowWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function ($$window) {
              var arg = $$window.id;
              var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
              var windowId = (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                  })("Expect to get windowId");
              return Promise.resolve([
                          $$window,
                          /* Windows */{
                            _0: {
                              windowIdsInBackgroundMode: Belt_Array.concat(windowIdsInBackgroundMode, [windowId]),
                              minimizedWindowIdMapPlaybackTabId: bridgeWindows.minimizedWindowIdMapPlaybackTabId
                            }
                          }
                        ]);
            });
}

function createWindowWithUrl$1(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, osBridge) {
  if (!osBridge) {
    return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function ($$window) {
                return Promise.resolve([
                            $$window,
                            osBridge
                          ]);
              });
  }
  var bridgeWindows = osBridge._0;
  var windowIdsInBackgroundMode = bridgeWindows.windowIdsInBackgroundMode;
  return createWindowWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function ($$window) {
              var arg = $$window.id;
              var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
              var windowId = (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                  })("Expect to get windowId");
              return Promise.resolve([
                          $$window,
                          /* Windows */{
                            _0: {
                              windowIdsInBackgroundMode: Belt_Array.concat(windowIdsInBackgroundMode, [windowId]),
                              minimizedWindowIdMapPlaybackTabId: bridgeWindows.minimizedWindowIdMapPlaybackTabId
                            }
                          }
                        ]);
            });
}

function createTab$1(windowId, index, url, active, selected, pinned, openerTabId, osBridge) {
  if (osBridge) {
    return createTab(windowId, index, url, active, selected, pinned, openerTabId, osBridge);
  } else {
    return Browser__Tabs$SmartcutsMacros.create(windowId, index, url, active, selected, pinned, openerTabId, undefined).then(function (tab) {
                return Promise.resolve([
                            tab,
                            osBridge
                          ]);
              });
  }
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.bridgeWindows_encode = bridgeWindows_encode;
exports.bridgeWindows_decode = bridgeWindows_decode;
exports.stringify = stringify;
exports.doesRequireWindowsBackgroundModeSupport = doesRequireWindowsBackgroundModeSupport;
exports.markWindowIdAsMinimized = markWindowIdAsMinimized;
exports.markWindowIdAsNotMinimized = markWindowIdAsNotMinimized;
exports.isWindowMinimized = isWindowMinimized;
exports.maybeMinimizedWindowIdForTab = maybeMinimizedWindowIdForTab;
exports.Windows = Windows;
exports.MacOsAndUnixLike = MacOsAndUnixLike;
exports.fromBrowserPlatformOs = fromBrowserPlatformOs;
exports.createWindowWithNoUrl = createWindowWithNoUrl$1;
exports.createWindowWithUrl = createWindowWithUrl$1;
exports.createTab = createTab$1;
/* Util-SmartcutsMacros Not a pure module */
